import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';


@Injectable()
export class ActiveRouteHeaderService {
  private currentRoutePath: string = '/';
  constructor(private router: Router) {
    // const { filter} = new Operator();
    this.currentRoutePath = this.router.url || '/';
    this.router.events
      .subscribe((e: any) => {
        if(e instanceof NavigationEnd){
          this.currentRoutePath = e.urlAfterRedirects || e.url || '/';
        }
      });
  }

  public getActiveRoute(): string {
    return this.currentRoutePath;
  }
}





// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/active-route-header.service.ts